import axiosInstance from '@/app/api/axiosInstance';
import { VapidPublicKeyResponse, WebPushSubscribeRequest } from '@/app/types/webPush';

export const getVapidPublicKey = async (): Promise<string> => {
    const response = await axiosInstance.get<VapidPublicKeyResponse>('/web-push/vapid-public-key');
    return response.data.public_key;
};

export const subscribeToWebPush = async (
    endpoint: string,
    p256dhKey: string,
    authKey: string,
    deviceLabel?: string,
    appType?: string
): Promise<void> => {
    const payload: WebPushSubscribeRequest = {
        endpoint,
        p256dh_key: p256dhKey,
        auth_key: authKey,
        device_label: deviceLabel,
        user_agent: navigator.userAgent,
        app_type: appType
    };

    await axiosInstance.post('/web-push/subscribe', payload);
};

export const unsubscribeFromWebPush = async (): Promise<void> => {
    await axiosInstance.delete('/web-push/unsubscribe');
};
